<div
  class="side-nav-overlay"
  [class.open]="showSideNav"
  (click)="itemClickEmit()"></div>
<div
  class="side-nav-container"
  (click)="itemClickEmit()"
  [class.open]="showSideNav">
  <div class="side-nav-element">
    <div class="user-balance-container" [ngSwitch]="pointsSummaryLoading()">
      <div class="content">
        <ng-container *ngSwitchCase="true">
          <div class="title-loading"></div>
          <div class="points-loading"></div>
        </ng-container>

        <ng-container *ngSwitchCase="false">
          <div class="title">{{ 'core.side_nav.you_have' | translate }}</div>
          <div class="points">
            <span class="big-number">{{
              pointsSummary.pointsBalance | localizeNumber
            }}</span>
            <span class="currency">{{ pointsCurrencyShortName() }}</span>
          </div>
        </ng-container>
      </div>

      <hr class="item-border title-border" />
    </div>

    <div class="nav-link-container">
      <ng-container *ngFor="let navLink of navLinks">
        <rd-core-side-nav-link (click)="itemClickEmit()" [navLink]="navLink">
        </rd-core-side-nav-link>
        <hr class="item-border" />
      </ng-container>
    </div>

    <div class="logout-button-container">
      <hr class="item-border" />

      <rd-core-side-nav-link
        class="logout"
        (clickEvent)="logoutEmit()"
        [navLink]="logoutNavLink">
      </rd-core-side-nav-link>
    </div>
  </div>
</div>
